'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _genericCategory = require('./generic-category.scss');

var _genericCategory2 = _interopRequireDefault(_genericCategory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    icon: _propTypes2.default.string,
    results: _propTypes2.default.array,
    CategoryResult: _propTypes2.default.func.isRequired, // Component
    emptyResultText: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    searchQuery: _propTypes2.default.string,
    offset: _propTypes2.default.number,
    highlightIndex: _propTypes2.default.number,
    savedQuery: _propTypes2.default.string.isRequired,
    setResultSelection: _propTypes2.default.func.isRequired,
    getContainerRect: _propTypes2.default.func.isRequired,
    scrollIntoView: _propTypes2.default.func.isRequired
};

var defaultProps = {
    icon: undefined,
    results: [],
    emptyResultText: 'No results found',
    onClick: function onClick() {},
    offset: 0,
    highlightIndex: -1
};

var GenericCategory = function (_React$PureComponent) {
    _inherits(GenericCategory, _React$PureComponent);

    function GenericCategory(props) {
        _classCallCheck(this, GenericCategory);

        var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

        _this.getCategoryResult = _this.getCategoryResult.bind(_this);
        return _this;
    }

    GenericCategory.prototype.getCategoryResult = function getCategoryResult(result, i) {
        return _react2.default.createElement(this.props.CategoryResult, {
            key: i,
            result: result,
            onClick: this.props.onClick,
            position: i + 1,
            icon: this.props.icon,
            searchQuery: this.props.searchQuery,
            index: i + this.props.offset,
            highlightIndex: this.props.highlightIndex,
            savedQuery: this.props.savedQuery,
            setResultSelection: this.props.setResultSelection,
            getContainerRect: this.props.getContainerRect,
            scrollIntoView: this.props.scrollIntoView
        });
    };

    GenericCategory.prototype.render = function render() {
        var _this2 = this;

        var results = this.props.results;


        return _react2.default.createElement(
            'div',
            { className: _genericCategory2.default.genericCategory },
            _react2.default.createElement(
                'div',
                { className: _genericCategory2.default.content },
                results.map(function (result, i) {
                    return _this2.getCategoryResult(result, i);
                }),
                this.props.results.length === 0 && this.props.emptyResultText
            )
        );
    };

    return GenericCategory;
}(_react2.default.PureComponent);

exports.default = GenericCategory;


GenericCategory.propTypes = propTypes;
GenericCategory.defaultProps = defaultProps;